import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import styled from 'styled-components';
import { IDistrictStat } from '../../../types/statistics.types';
import useWindowWidth from '../../../utils/use.window.width';

const Wrapper = styled.div`
  margin-top: 30px;
  margin-bottom: 50px;
  width: 100%;

   svg, path, g {
    outline: none !important;
    focus-visible: none;
  }
    
  @media(max-width: 1024px) {
  margin-top: 0px;
  }
`;

const Title = styled.h2`
  font-family: "e-Ukraine", sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 114%;
  text-align: justify;
  color: #000;
  margin-bottom: 15px;

  @media(max-width: 530px ){
    font-size: 15px;
    margin: 0 0 10px;
  }
`;

const DateRange = styled.p`
  font-family: "e-Ukraine", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 114%;
  text-align: justify;
  color: #8f8f8f;
  margin: 0 0 20px;

  @media(max-width: 530px ){
    font-size: 12px;
  }
    
`;

const TooltipBox = styled.div`
  background: #fff;
  font-family: "e-Ukraine-Head", sans-serif;
  border: 1px solid #d4e8dc;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 13px;
  color: #1a1a1a;
  font-weight: 600;

  span {
    color:#1a7a4a;
  }
`;

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload?.length) {
    return (
      <TooltipBox>
        {label}: <span>{payload[0].value.toLocaleString('uk-UA')}</span>
      </TooltipBox>
    );
  }
  return null;
};

interface Props {
  data: IDistrictStat[];
  dateRange: string;
}

export const DistrictChartComponent: React.FC<Props> = ({ data, dateRange }) => {
    const windowWidth = useWindowWidth()
    const isMobile = windowWidth <= 530
    const isTablet = windowWidth <= 768
    const isMediumDesktop = windowWidth <= 1200

  const chartData = data.map((d) => ({
    name: d.districtName,
    total: d.total,
  }));

 
  const fontSize =  isMobile  ? 12 : isTablet ? 15 : 20;
  const barSize = isMobile ? 32 : 52;
  const rowHeight = isMobile ? 45 : 70; 
  
  const yAxisWidth = isMobile ? 160:  isTablet  ? 40 : isMediumDesktop ? 80 : 300; 
  const chartMargin = isMobile 
    ? { top: 0, right: 20, left: -20, bottom: 0 } 
    : { top: 0, right: 160, left: 140, bottom: 0 };

  return (
    <Wrapper>
      <Title>Розподіл звернень по районам міста</Title>
      <DateRange>{dateRange}</DateRange>
      
      <ResponsiveContainer width="100%" height={data.length * rowHeight + 20}>
        <BarChart
          layout="vertical"
          data={chartData}
          margin={chartMargin}
          barSize={barSize}
        >
          <CartesianGrid horizontal={false} stroke="#f0f0f0" />
          <XAxis type="number" hide />
          <YAxis
            type="category"
            dataKey="name"
            width={yAxisWidth}
            tick={{ 
              fontSize: fontSize, 
              fill: '#555', 
              fontWeight: 400, 
              fontFamily: "e-Ukraine-Head" 
            }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(26,122,74,0.06)' }} />
          <Bar dataKey="total" fill="#01924f" radius={[0, 3, 3, 0]}>
            <LabelList
              dataKey="total"
              position="insideLeft"
              style={{ 
                fill: '#fff', 
                fontSize: fontSize, 
                fontWeight: 700, 
                fontFamily: "e-Ukraine-Head" 
              }}
              formatter={(v: any) => v?.toLocaleString('uk-UA')}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Wrapper>
  );
};